import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import NotifyItem from './NotifyItem';


class NotificationsList extends React.PureComponent {

	render() {
		if(!this.props.notifications.length) {
			return <div>No notifications to display</div>
		}

		return (
			<List dense>

				{
					this.props.notifications.map((notification, index) => {
						let note = notification.Remarks.length > 50
							? `${notification.Remarks.substr(0, 50)}...`
							: notification.Remarks;
						let activity;

						switch(notification.Class) {
							case 'C':
								activity = 'Phone Call'; break;
							case 'M':
								activity = 'Meeting'; break;
							case 'T':
								activity = 'Task'; break;
							case 'E':
								activity = 'Note'; break;
							case 'P':
								activity = 'Campaign'; break;
							default:
								activity = 'Other';
						}

						return (
							<NotifyItem
								category={`${activity} - ${notification.CardName}`}
								text={note}
								link={`/businesspartners/view/${notification.CardCode}/activity/${notification.ClgCode}`}
								notificationID={index}
								isRead={false}
								handleClose={this.props.handleClose}
								key={index}
							/>
						);
					})
				}

			</List>
		);
	}
}


NotificationsList.propTypes = {
	notifications: PropTypes.array.isRequired,
	handleClose: PropTypes.func.isRequired,
};

export default NotificationsList;